import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SrText from 'client/components/SrText';

import SrSafariToolbarSpace from 'client/components/SrSafariToolbarSpace';
import SrModalV2, { MODAL_THEME_SLIDE_UP } from 'client/components/SrModalV2/SrModalV2';
import SrButton, { SR_BUTTON_THEME_ADOBE_GREEN } from 'client/components/SrButton/SrButton';
import SrFlex from 'client/components/SrFlex';

class SrSelfTourCodeboxReturnKeyModal extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const { onSubmit } = this.props;

    return (
      <SrModalV2
        showCloseButton={false}
        contentMaxWidth="555px"
        padding="0"
        contentPadding="50px 25px 30px"
        theme={MODAL_THEME_SLIDE_UP}
      >
        <SrText
          font="greycliff"
          weight="800"
          size="26"
          lineHeight="33px"
          align="start"
          width="100%"
          display="block"
        >
          Important Steps
        </SrText>
        <SrText font="greycliff" weight="500" size="20" color="green">
          Before exiting,&nbsp;
        </SrText>
        <SrText font="greycliff" weight="500" size="20">
          take care to
        </SrText>
        <SrFlex align="center" direction="col">
          <img style={{ maxWidth: '100%' }} src="/images/codebox-return-key-modal.png" alt="" />
        </SrFlex>
        <SrButton theme={SR_BUTTON_THEME_ADOBE_GREEN} onClick={onSubmit}>
          Ok, Got it
        </SrButton>

        <SrSafariToolbarSpace />
      </SrModalV2>
    );
  }
}

SrSelfTourCodeboxReturnKeyModal.displayName = 'SrSelfTourCodeboxReturnKeyModal';

export default SrSelfTourCodeboxReturnKeyModal;
